import Settings from "src/objects/Settings";

interface Scores {  
    score:number;
    stat:number;
}

interface ImpactScoreValues {  
    tiny:number;
    small:number;
    medium:number;
    large:number;
    huge:number;
}

export default class ScoreUtils {

    public static BASE_SCORE:number = 10; // min score for each decision
    public static BONUS_COUNTDOWN:number = 20;
    
    public static gameNegativeTotals:ImpactScoreValues = {
        tiny: 0,
        small: 0,
        medium: 0,
        large: 0,
        huge: 0,
    }

    public static gamePositiveTotals:ImpactScoreValues = {
        tiny: 0,
        small: 0,
        medium: 0,
        large: 0,
        huge: 0,
    }

    // public static impactScoreValues:ImpactScoreValues = {
    //     tiny: 20,
    //     small: 50,
    //     medium: 100,
    //     large: 250,
    //     huge: 500,
    // };

    // public static impactStatValues:ImpactScoreValues = {
    //     tiny: 5,
    //     small: 15,
    //     medium: 30,
    //     large: 50,
    //     huge: 100,
    // };

    public static resetTotals() {
        ScoreUtils.gamePositiveTotals = {
            tiny: 0,
            small: 0,
            medium: 0,
            large: 0,
            huge: 0,
        }

        ScoreUtils.gameNegativeTotals = {
            tiny: 0,
            small: 0,
            medium: 0,
            large: 0,
            huge: 0,
        }
    }

    public static getImpactScores(impact:string, settings:Settings):Scores {
        let scores:Scores = {
            score: 0,
            stat: 0
        }
        switch (impact) {
            case "Tiny":
                scores.score = settings.impactScoreValues.tiny;
                scores.stat = settings.impactStatValues.tiny;
                break;
            case "Small":
                scores.score = settings.impactScoreValues.small;
                scores.stat = settings.impactStatValues.small;
                break;
            case "Medium":
                scores.score = settings.impactScoreValues.medium;
                scores.stat = settings.impactStatValues.medium;
                break;
            case "Large":
                scores.score = settings.impactScoreValues.large;
                scores.stat = settings.impactStatValues.large;
                break;
            case "Huge":
                scores.score = settings.impactScoreValues.huge;
                scores.stat = settings.impactStatValues.huge;
                break;
            default:
                console.log("Unknown impact score");
                break;
        }
        return scores;
    }
}


// WEBPACK FOOTER //
// ./src/utils/ScoreUtils.ts